import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoMgo: CultureInfo = {
  name: 'mgo',
  displayName: 'metaʼ',
  iso3LanguageCode: 'mgo',
  iso2LanguageCode: 'mgo',
  ietfLanguageTag: 'mgo',
  parent: null
};
